"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 1,
    class: "wf-root"
};
const _hoisted_2 = { for: "suspend-checkbox" };
const _hoisted_3 = { key: 0 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_player_input_factory = (0, vue_1.resolveComponent)("player-input-factory");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", null, [
        (_ctx.waitingfor === undefined)
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.$t('Not your turn to take any actions')) + " ", 1),
                (_ctx.playersWaitingFor.length > 0)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                        _cache[2] || (_cache[2] = (0, vue_1.createTextVNode)(" (⌛ ", -1)),
                        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.playersWaitingFor, (color) => {
                            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", {
                                class: (0, vue_1.normalizeClass)(_ctx.playerColorClass(color, 'bg')),
                                key: color
                            }, "   ", 2));
                        }), 128)),
                        _cache[3] || (_cache[3] = (0, vue_1.createTextVNode)(") ", -1))
                    ], 64))
                    : (0, vue_1.createCommentVNode)("", true)
            ], 64))
            : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
                (_ctx.preferences().experimental_ui && _ctx.playerView.game.phase === _ctx.Phase.ACTION)
                    ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, { key: 0 }, [
                        (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                            type: "checkbox",
                            name: "suspend",
                            id: "suspend-checkbox",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.suspend) = $event)),
                            onChange: _cache[1] || (_cache[1] =
                                (...args) => (_ctx.updateSuspend && _ctx.updateSuspend(...args)))
                        }, null, 544), [
                            [vue_1.vModelCheckbox, _ctx.suspend]
                        ]),
                        (0, vue_1.createElementVNode)("label", _hoisted_2, [
                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[4] || (_cache[4] = [
                                    (0, vue_1.createTextVNode)("Suspend", -1)
                                ]))])), [
                                [_directive_i18n]
                            ])
                        ]),
                        (_ctx.showRefresh())
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [...(_cache[5] || (_cache[5] = [
                                    (0, vue_1.createTextVNode)("Refresh", -1),
                                    (0, vue_1.createElementVNode)("span", { class: "reset" }, null, -1)
                                ]))]))
                            : (0, vue_1.createCommentVNode)("", true)
                    ], 64))
                    : (0, vue_1.createCommentVNode)("", true),
                (0, vue_1.createVNode)(_component_player_input_factory, {
                    players: _ctx.players,
                    playerView: _ctx.playerView,
                    playerinput: _ctx.waitingfor,
                    onsave: _ctx.onsave,
                    showsave: true,
                    showtitle: true
                }, null, 8, ["players", "playerView", "playerinput", "onsave"])
            ]))
    ]));
}
